import {
  Box,
  Disclosure,
  DisclosureContent,
  DisclosureTrigger,
  Flex,
  Text,
} from '@optiaxiom/react';

import { MarkdownText } from '@frontend/components/MarkdownText';

type ToolCallDisplayProps = {
  toolName: string;
  inputContent: string;
  outputContent: string;
  variant?: 'inline' | 'expanded';
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  inputOpen?: boolean;
  onInputOpenChange?: (open: boolean) => void;
  outputOpen?: boolean;
  onOutputOpenChange?: (open: boolean) => void;
};

export function ToolCallDisplay({
  toolName,
  inputContent,
  outputContent,
  variant = 'expanded',
  open = false,
  onOpenChange = () => {},
  inputOpen = false,
  onInputOpenChange = () => {},
  outputOpen = false,
  onOutputOpenChange = () => {},
}: ToolCallDisplayProps) {
  return (
    <Disclosure open={open} onOpenChange={onOpenChange}>
      <Box border="1" p="4" borderColor="border.default" rounded="md">
        <DisclosureTrigger>
          <Box p="4" w="full">
            <Flex flexDirection="row" justifyContent="flex-start" alignItems="center">
              <Box w="64">
                <Text fontSize="sm" fontWeight="600" color="fg.default">
                  Tool Call
                </Text>
              </Box>
              <Box w="full">
                <Text fontSize="sm" color="fg.secondary" lineClamp="1">
                  {toolName}
                </Text>
              </Box>
            </Flex>
          </Box>
        </DisclosureTrigger>
        <DisclosureContent>
          <Box p="12" bg="bg.default">
            {variant === 'inline' ? (
              <Flex flexDirection="row" gap="16">
                <Box flex="1">
                  <Disclosure open={inputOpen} onOpenChange={onInputOpenChange}>
                    <DisclosureTrigger>
                      <Box w="full" p="8" bg="bg.secondary" rounded="md">
                        <Text fontSize="sm" fontWeight="600" color="fg.default">
                          Parameters
                        </Text>
                      </Box>
                    </DisclosureTrigger>
                    <DisclosureContent>
                      <Box p="8">
                        <MarkdownText text={inputContent} />
                      </Box>
                    </DisclosureContent>
                  </Disclosure>
                </Box>
                <Box flex="1">
                  <Disclosure open={outputOpen} onOpenChange={onOutputOpenChange}>
                    <DisclosureTrigger>
                      <Box w="full" p="8" bg="bg.secondary" rounded="md">
                        <Text fontSize="sm" fontWeight="600" color="fg.default">
                          Output
                        </Text>
                      </Box>
                    </DisclosureTrigger>
                    <DisclosureContent>
                      <Box p="8">
                        <MarkdownText text={outputContent} />
                      </Box>
                    </DisclosureContent>
                  </Disclosure>
                </Box>
              </Flex>
            ) : (
              <Flex flexDirection="column" gap="16">
                <Disclosure open={inputOpen} onOpenChange={onInputOpenChange}>
                  <DisclosureTrigger>
                    <Box w="full" p="8" bg="bg.secondary" rounded="md">
                      <Text fontSize="sm" fontWeight="600" color="fg.default">
                        Input Variables
                      </Text>
                    </Box>
                  </DisclosureTrigger>
                  <DisclosureContent>
                    <Box p="8">
                      <MarkdownText text={inputContent} />
                    </Box>
                  </DisclosureContent>
                </Disclosure>
                <Disclosure open={outputOpen} onOpenChange={onOutputOpenChange}>
                  <DisclosureTrigger>
                    <Box w="full" p="8" bg="bg.secondary" rounded="md">
                      <Text fontSize="sm" fontWeight="600" color="fg.default">
                        Output
                      </Text>
                    </Box>
                  </DisclosureTrigger>
                  <DisclosureContent>
                    <Box p="8">
                      <MarkdownText text={outputContent} />
                    </Box>
                  </DisclosureContent>
                </Disclosure>
              </Flex>
            )}
          </Box>
        </DisclosureContent>
      </Box>
    </Disclosure>
  );
}
